import { memo } from 'react';

import { Typography } from '@mui/material';

import { formatDate } from '@/shared/lib/format';

import { DATE_NUMBER_CELL_SX } from './cells.styles';

export interface DateCellProps {
  value: string | Date | null | undefined;
}

export const DateCell = memo(({ value }: DateCellProps) => (
  <Typography variant="body2" sx={DATE_NUMBER_CELL_SX}>
    {formatDate(value)}
  </Typography>
));
DateCell.displayName = 'DateCell';
